import React, { Component } from 'react';
class Abt extends React.Component {

    render() {
        return (
            <div>Abt</div>
        );
    }
}
export default Abt;